import { SlideFrame } from '../SlideFrame';

// Combined Committed + Track Record slide (2026-05-15 restructure).
// Top half: 3 commitment cards (alignment).
// Bottom half: 3 stat cards showing the honest position — we are
// compounding, but slightly behind the benchmark. That gap sets up
// the Ackman / Visualizer pivot on the next two slides.
// Track record numbers: 2020-2026YTD compounded from Slide16 data.
const CARDS = [
  { big: '100%', caption: 'of our investible capital is in the Fund' },
  { big: '25%+', caption: 'of Fund assets owned by Triumph principals' },
  { big: 'Every $', caption: 'earned at Triumph rolls back into the Fund' },
];

const RETURN_STATS = [
  { big: '+12.4%', caption: 'Annualized return, 2020 to today', tone: 'pos' as const },
  { big: '−1.8pp', caption: 'vs S&P 500 over the same period', tone: 'neg' as const },
  { big: '+102.7%', caption: 'Cumulative return since 2020', tone: 'pos' as const },
];

export function Slide03Committed() {
  return (
    <SlideFrame pageNum={3} title="COMMITTED. COMPOUNDING."
      banner="Our wealth grows when yours does. But we can do better.">
      <div className="grid grid-rows-2 gap-4 h-full pt-2 pb-4">
        {/* Top row — commitment cards */}
        <div className="grid grid-cols-3 gap-5 items-stretch">
          {CARDS.map(c => (
            <div key={c.big} className="bg-[#1e293b] rounded-2xl px-6 py-4 flex flex-col items-center justify-center">
              <div className="text-[#c9a84c] text-[44px] font-bold tabular-nums leading-none mb-2">{c.big}</div>
              <div className="text-[#cbd5e1] text-center text-[17px] leading-snug">{c.caption}</div>
            </div>
          ))}
        </div>
        {/* Bottom row — return stats */}
        <div className="grid grid-cols-3 gap-5 items-stretch">
          {RETURN_STATS.map(c => (
            <div key={c.big} className="bg-[#0f1623] rounded-2xl px-6 py-4 flex flex-col items-center justify-center border border-[#334155]">
              <div className={`text-[44px] font-bold tabular-nums leading-none mb-2 ${c.tone === 'neg' ? 'text-[#fbbf24]' : 'text-emerald-400'}`}>{c.big}</div>
              <div className="text-[#cbd5e1] text-center text-[15px] leading-snug">{c.caption}</div>
            </div>
          ))}
        </div>
      </div>
    </SlideFrame>
  );
}
